import { createAction } from "@reduxjs/toolkit";
import type { GetOrganizationDevicesResponse } from "@somewear/api";
import { createActionSet } from "@somewear/model";

export const emitOrganizationDevicesFetchedFromServer =
	createAction<GetOrganizationDevicesResponse.AsObject>(
		"emitOrganizationDevicesFetchedFromServer",
	);

export const organizationDeviceActions = {
	getDevices: createActionSet<void, GetOrganizationDevicesResponse.AsObject>(
		"organization/devices/get",
	),
};
